<template>
  <div class="page-container">
    <div class="header">
      <span class="page-title">公司管理</span>
    </div>
    <div class="card-content">
      <div class="search-bar">
        <a-input v-model:value="searchText" type="text" style="width:200px" placeholder="公司名稱"/>
        <a-select v-model:value="filterStatus" style="width: 120px">
          <a-select-option value="">請選擇狀態</a-select-option>
          <a-select-option value="true">正常</a-select-option>
          <a-select-option value="false">停權</a-select-option>
        </a-select>
        <a-button @click="filterData">搜尋</a-button>
        <a-button @click="navigateToAdd" type="primary" class="btn-add">+ 新增</a-button>
      </div>


      <a-table :columns="columns"
               :data-source="filteredData"
               rowKey="id"
               :custom-row="customRow"
               :rowClassName="() => (`row`)">

        <template v-slot:bodyCell="props">
          <div v-if="props.column.key === 'action'">
            <span>
              <a-dropdown :trigger="['click']">
                <a-button class="ant-dropdown-link btn-action" @click.prevent>
                  <img src="@/assets/ic_more.svg" class="icon"/>
                </a-button>
                <template #overlay>
                  <a-menu>
                    <a-menu-item key="0">
                      <a @click="performAction(props.record, 'edit')">編輯</a>
                    </a-menu-item><a-menu-divider/>
                    <a-menu-item key="1">
                      <a @click="performAction(props.record, 'suspend')">{{ props.record.is_active ? `停權` : `復權` }}</a>
                    </a-menu-item><a-menu-divider/>
                    <a-menu-item key="3">
                      <a @click="performAction(props.record, 'delete')" style="color: red">刪除</a>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </span>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import {message, Modal} from 'ant-design-vue';


export default {
  name: "CompanyPage",
  data() {
    return {
      items: [],
      searchText: "",
      filterStatus: "",

      columns: [
        {
          title: '公司名稱',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '管理者',
          key: 'administrator',
          customRender: ({record}) => {
            const owner = record.users.filter((item) => item.role === "admin")[0]
            return `${owner?.last_name + owner?.first_name || ""}`;
          },
        },
        {
          title: '電子信箱',
          key: 'email',
          customRender: ({record}) => {
            const owner = record.users.filter((item) => item.role === "admin")[0]
            return `${owner?.email || ""}`;
          },
        },
        {
          title: '狀態',
          key: 'status',
          customRender: ({record}) => {
            return record.is_active ? '正常' : '停權'
          }
        },
        {
          title: '操作',
          key: 'action'
        },
      ],


    };
  },
  computed: {
    filteredData() {
      let data = this.items;

      if (this.searchText) {
        data = data.filter((item) =>
            item.name.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }

      if (this.filterStatus) {

        if (this.filterStatus === '') {
          data = this.items;
        } else {
          const isActive = this.filterStatus === "true";
          data = this.items.filter((item) => item.is_active === isActive);
        }
      }

      return data;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {

      const token = localStorage.getItem('token');
      this.$axios.get('/api/organizations', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        this.items = response.data.data;
        console.log(response.data.data);
      }).catch(error => {
        console.error(error.status);
        if (error.status === 401) {
          this.$router.push('/login');
        }
      });
    },
    filterData() {

    },
    navigateToAdd() {
      this.$router.push('/company/add');
    },
    customRow(item) {
      return {
        onClick: (e) => {
          if (['img', 'button'].includes(e.target.tagName.toLowerCase())) return;
          this.$router.push({name: 'CompanyView', params: {id: item.id}})
          e.stopPropagation()
        }
      }
    },
    performAction(item, action) {
      console.log(`執行 ${action} 操作, 用戶：${item.id}`);

      const token = localStorage.getItem('token');
      const isActive = item.is_active;

      switch (action) {
        case 'edit':
          this.$router.push({name: 'CompanyEdit', params: {id: item.id}});
          break;
        case 'suspend':

          this.$axios.patch(`/api/organizations/${item.id}`, {
            is_active: !isActive
          }, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }).then(response => {
            console.log(response.data.data);
            this.fetchData();
            message.success(`已將公司${isActive ? "停權" : "復權"}`);
          }).catch(error => {
            console.error(error.status);
            if (error.status === 401) {
              this.$router.push('/login');
            }
          });
          break;
        case 'delete':

          Modal.confirm({
            title: '刪除公司',
            content: '將會同步刪除此公司所有相關帳號以及設備，確認要刪除此公司帳號嗎？',
            okText: '刪除',
            okType: 'primary',
            okButtonProps: {
              danger: true
            },
            cancelText: '取消',
            onOk: () => {

              this.$axios.delete(`/api/organizations/${item.id}`, {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              }).then(response => {
                console.log(response.data.data);
                this.fetchData();
                message.success('已將公司刪除');
              }).catch(error => {
                console.error(error.status);
                if (error.status === 401) {
                  this.$router.push('/login');
                }
              });
            },
          });

          break;
      }
    }
  },
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  margin-top: 16px;
  padding: 20px;
}

.search-bar {
  margin-bottom: 1em;
  display: flex;
  gap: 10px;
}

.btn-add {
  margin-left: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.status-active {
  color: green;
}

.status-inactive {
  color: red;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 10px;
}

button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-action {
  border-radius: 8px;
  border: none;
  background-color: #f5f5fa;
}
</style>
